export default function limitValue(value, min, max) {
    return Math.max(Math.min(value, max), min);
}


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-drawing/dist/es/util/limit-value.js
// module id = ../../../../@progress/kendo-drawing/dist/es/util/limit-value.js
// module chunks = vendor